<div class="valid-field-info" *ngIf="isValid">
  <img src="/assets/images/ic-field-valid.svg" alt="icon" />
  <span>Congratulations! The field is valid</span>
</div>
